export default __webpack_public_path__ + "static/media/UMN-Framework for Planning-07.05dbe2a5.jpg";